// VzmStyled.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import { styled } from '@mui/material/styles';
import { Box, Button, Chip } from '@mui/material';
import { AppStyle } from '../value/AppConst';

export const ValueMargin = '14px 0px 14px 0px';

export const VzmSubject = styled(Box)({
    fontSize:'1.1rem', fontWeight:'bold', color:'#222', boxSizing:'border-box',
    backgroundColor:'#eee',
    borderTopLeftRadius:5, borderTopRightRadius:5,
    display:'flex', alignItems:'center', paddingLeft:20, paddingRight:10, height:48
});

export const WhiteChip = styled(Chip)(({ theme }) => ({
    backgroundColor: "#fff", fontSize: '0.9rem', fontWeight: 'bold',
    color: AppStyle.PrimaryRGB,
}));

export const VzmInputBlock = styled(Box)({ padding: '10px 0px 10px 0px', });
export const VzmInputFlex= styled(Box)({ display:'flex', padding: '10px 0px 10px 0px', alignItems:'center' });
export const VzmLabel = styled('div')({
    fontSize: '0.8rem',
    //fontWeight: 'bold',
    color: AppStyle.PrimaryRGB,
    marginBottom: 2, marginTop: 2, minWidth: 70,
});

export const VzmDataText = styled('span')({
    marginLeft: '0.5rem',
});

export const VzmMemoText = styled('div')({
    backgroundColor: '#f7f7f7',
    borderRadius:5,whiteSpace:'pre-line',
    padding:10,
    marginLeft: '0.5rem',
});

export const NonCapButton = styled(Button)({
    textTransform: 'none !important',
});

// DialogActions 좌측에 배치할 상자.
export const ErrorHintBox = styled(Box)({
    flexGrow: 1, border: '1px solid #fcc', borderRadius: 10, padding: 5,
    fontSize: '0.8rem', color: '#f88', marginRight: 10,
    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
});

export const VPBox = styled(Box)({position:'relative', paddingTop:8});
export const VPLabel = styled('div')({
    fontSize:'0.8rem', color:AppStyle.PrimaryRGB, padding:'0px 5px 0px 5px',
    position:'absolute', top:0, left:10, borderRadius:7, backgroundColor: 'white',
});
/*
    textShadow:'0px 0px 5px white',
*/
export const VPDataBox = styled(Box)({
    padding:'10px 3px 8px 10px', borderRadius:5, border:AppStyle.BorderCCC,
    minHeight: 40, boxSizing:'border-box',
    '&:hover': {background: 'linear-gradient(white, #ddd)'},
});

const VPMemoText = styled(Box)({
    whiteSpace:'pre-line',
    padding:'10px 3px 8px 10px', borderRadius:5, border:AppStyle.BorderCCC
});
export const VzmPrint = ({
    label, labelColor, color,
    value, marginBottom,
}) => {
    return (
        <VPBox style={{marginBottom: marginBottom || 0}}>
            <VPDataBox style={{color:color || 'inherit'}}>
                {value===undefined || value===null ? <span>&nbsp;</span> : value}</VPDataBox>
            <VPLabel style={{color:labelColor || AppStyle.PrimaryRGB}}>{label}</VPLabel>
        </VPBox>
    );
};

export const VzmPrintHHMM = ({
    label,
    value,
}) => {
    return (
        <VzmPrint label={label} text={value ? value.substring(0, 2) + ':' + value.substring(2, 4) : null} />
    );
};

export const VzmPrintMemo = ({
    label,
    text: value,
}) => {
    return (
        <VPBox>
            <VPMemoText>{value}</VPMemoText>
            <VPLabel>{label}</VPLabel>
        </VPBox>
    );
};

const FlexCenterBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const VzmFullMessage = ({
    message,
    color,
    fontSize,
}) => {
    return (
        <FlexCenterBox>
            <span style={{
                color: color ? color : '#0df',
                fontSize: fontSize ? fontSize : '1.2rem',
            }}>
                {message}
            </span>
        </FlexCenterBox>
    );
};

